// extracted by mini-css-extract-plugin
export default {"partners":"Partners_partners__Ldfvy","partners_main":"Partners_partners_main__zf6Ou","slide":"Partners_slide__1IUiD"};